import { lowerCase, videoPlayPromise } from "./helpers";

$(document).on("short-video:section:short-video", function () {
    // check if have section#short-video run swupShortVideo
    if ($("section#section-short-video").length > 0) {
        // rebuild swiperGrid
        swupShortVideo();
        $(document).trigger("short-video:startTransition");
    }
});

$(document).on("short-video:startTransition", function () {
    if ($(".swiper-short-video").length > 0) {
        let tl = gsap.timeline();

        tl.fromTo(
            ".sidebar-short-video",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 0.5,
                ease: "power2.out",
            }
        );

        tl.fromTo(
            ".sidebar-short-video-categories li",
            {
                transform: "translateY(-300%)",
                opacity: 0,
            },
            {
                transform: "translateY(0)",
                duration: 0.5,
                opacity: 1,
                stagger: 0.2,
                ease: "power2.out",
            },
            "<"
        );

        tl.addLabel("swiper-short-video", "<");

        tl.fromTo(
            ".swiper-short-video .swiper-short-video-item-outer",
            {
                x: 400,
                opacity: 0,
            },
            {
                x: 0,
                opacity: 1,
                duration: 2,
                ease: "ease",
                stagger: function (index) {
                    // 1 row 4 column
                    if (index % 4 === 0) {
                        return 0.5;
                    }

                    if (index % 4 === 1) {
                        return 0.6;
                    }

                    if (index % 4 === 2) {
                        return 0.7;
                    }

                    if (index % 4 === 3) {
                        return 0.8;
                    }
                },
            },
            "swiper-short-video"
        );

        tl.fromTo(
            ".swiper-short-video",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
            },
            "<"
        );

        tl.addLabel("section-content-2", "<");

        tl.fromTo(
            ".mil-portfolio-btns-frame",
            {
                opacity: 0,
                transform: "translateY(100%)",
            },
            {
                opacity: 1,
                duration: 1,
                transform: "translateY(0)",
                ease: "ease",
            },
            "section-content-2"
        );

        tl.pause();

        setTimeout(() => {
            tl.play();
        }, 1000);
    }
});

function swupShortVideo() {
    let swiperOption = {
        parallax: true,
        spaceBetween: 20,
        breakpoints: {
            // lg
            0: {
                slidesPerView: 1,
                grid: false,
                navigation: {
                    nextEl: ".mil-portfolio-next",
                    prevEl: ".mil-portfolio-prev",
                },
                pagination: {
                    el: ".swiper-portfolio-pagination",
                    type: "fraction",
                },
            },
            768: {
                slidesPerView: 2,
                grid: false,
                navigation: {
                    nextEl: ".mil-portfolio-next",
                    prevEl: ".mil-portfolio-prev",
                },
                pagination: {
                    el: ".swiper-portfolio-pagination",
                    type: "fraction",
                },
            },
            992: {
                slidesPerView: 4,
                grid: {
                    rows: 30,
                    fill: "row",
                },
                pagination: false,
                navigation: false,
            },
        },
    };

    const swiperGrid = new Swiper(".swiper-short-video", swiperOption);

    let type = $(".swiper-short-video").data("type");

    $.ajax({
        url: "/assets/web/default/json/short-video.json",
        async: false,
        success: function (data) {
            // filter data by type
            if (type !== undefined) {
                data = data.filter(function (item) {
                    // item.type is an array
                    return item.type.map(lowerCase).includes(type);
                });
            }

            let html = [];
            $.each(data, function (_, value) {
                html.push(`
                    <div class="swiper-slide">
                        <div class="swiper-short-video-item-outer">
                            <div class="swiper-short-video-item" style="--short-bg-color: ${
                                value.label_color
                            }; --item-pointer-events: auto;">
                                <div class="ratio ratio-6x10">
                                    <img src="${
                                        value.poster
                                    }" alt="${value.title}" style="object-fit: cover;" loading="lazy">
                                </div>
                                <div class="short-video-name">
                                    <div class="short-video-brand">
                                        <h4 class="mb-0">${value.title}</h4>
                                        <h6 class="mb-0">${value.label}</h6>
                                    </div>

                                    <div class="short-video-actions">
                                        ${
                                            type == undefined
                                                ? `<a href="/short-video/detail#slide-${value.id}" data-swup-preload class="mil-zoom-btn btn-play mil-hover-scale js-play-short-video">
                                                <i class="fas fa-play"></i>
                                            </a>`
                                                : `<a href="/short-video/detail?type=${value.type[0]}#slide-${value.id}" data-swup-preload class="mil-zoom-btn btn-play mil-hover-scale js-play-short-video">
                                                <i class="fas fa-play"></i>
                                            </a>`
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
            });

            swiperGrid.appendSlide(html);
        },
    });
}

$(document).on("short-video-detail:section:short-video-detail", function () {
    // check if have section#short-video-detail run swupShortVideoDetail
    if ($("section#section-short-video-detail").length > 0) {
        // rebuild swiperGrid
        swupShortVideoDetail();
        $(document).trigger("short-video-detail:startTransition");
    }
});

$(document).on("short-video-detail:startTransition", function () {
    let tween = gsap.fromTo(
        ".swiper-short-video-detail",
        {
            x: 400,
            opacity: 0,
        },
        {
            x: 0,
            opacity: 1,
            duration: 2,
            ease: "power2.out",
        }
    );

    tween.pause();

    setTimeout(() => {
        tween.play();
    }, 1000);
});

function swupShortVideoDetail() {
    let is_mute = true;

    let swiperOption = {
        // parallax: true,
        centeredSlides: true,
        breakpoints: {
            // lg
            0: {
                slidesPerView: 1.4,
            },
            992: {
                slidesPerView: 2.4,
            },
        },
        // offset
        hashNavigation: {
            watchState: true,
            replaceState: true,
        },
        // custom next and prev
        navigation: {
            nextEl: ".swiper-c-button-next",
            prevEl: ".swiper-c-button-prev",
        },
        virtual: {
            renderSlide: function (slide) {
                let hash = window.location.hash;
                let currentIndex = 0;
                if (hash) {
                    currentIndex = hash.replace("#slide-", "");
                }
                return `
                    <div class="swiper-slide" data-hash="slide-${slide.id}">
                        <div class="swiper-short-video-item" style="--short-bg-color: ${
                            slide.label_color
                        }; --item-pointer-events: auto;">
                            <div class="ratio ratio-6x10">
                                <div class="position-relative">
                                <button type="button" class="btn-volume-video js-volume" data-toggle="volume" aria-pressed="false" autocomplete="off">
                                    <i class="fas fa-volume-mute"></i>
                                </button>
                                <video muted playsinline poster="${
                                    slide.poster
                                }" preload="metadata" ${
                    currentIndex == slide.id ? "autoplay" : ""
                } loading="lazy" volume="0.1">
                                    <source src="${
                                        slide.video
                                    }" type="video/mp4">
                                    Your browser does not support the video tag.
                                </video>
                                <div class="short-video-actions-overlay">
                                    <a class="mil-zoom-btn btn-play mil-hover-scale"
                                        aria-label="Play" href="#">
                                        <i class="fas fa-play"></i>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            },
            slides: (function () {
                let slides = [];

                $.ajax({
                    url: "/assets/web/default/json/short-video.json",
                    async: false,
                    success: function (data) {
                        // get link parameter of type
                        let type = new URLSearchParams(
                            window.location.search
                        ).get("type");

                        $.each(data, function (key, value) {
                            if (type !== null) {
                                if (value.type.map(lowerCase).includes(type)) {
                                    slides.push(value);
                                }
                            } else {
                                slides.push(value);
                            }
                        });
                    },
                });

                return slides;
            })(),
        },
        on: {
            init: function () {
                // get hash and set active slide
                let hash = window.location.hash;
                if (hash) {
                    let slide = hash.replace("#slide-", "");
                    this.slideTo(
                        this.virtual.slides.findIndex((s) => s.id == slide)
                    );
                }
            },
        },
    };

    const swiperHorizontal = new Swiper(
        ".swiper-short-video-detail",
        swiperOption
    );

    function videoVolumeSettings() {
        $(".swiper-short-video-detail video").off("volumechange");
        $(".swiper-short-video-detail video").off("playing");
        $(document).off("click", ".js-volume");
        $(".swiper-short-video-detail video").off("ended");

        $(".swiper-short-video-detail video").on("volumechange", function () {
            this.volume = 0.1;
            let volumeButton = $(this)
                .closest(".swiper-slide")
                .find(".js-volume");
            let mute = this.muted;

            if (mute) {
                volumeButton
                    .find("i")
                    .removeClass("fa-volume-up")
                    .addClass("fa-volume-mute");
            } else {
                volumeButton
                    .find("i")
                    .removeClass("fa-volume-mute")
                    .addClass("fa-volume-up");
            }
        });

        $(".swiper-short-video-detail video").on("playing", function () {
            this.muted = is_mute;
        });

        // on click volume button mute or unmute
        $(document).on("click", ".js-volume", function () {
            is_mute = !is_mute;
            let video = $(this).closest(".swiper-slide").find("video")[0];
            video.muted = !video.muted;
        });

        // play video finish will go next slide
        $(".swiper-short-video-detail video").on("ended", function () {
            $(".swiper-short-video-detail video").each(function () {
                this.pause();
            });
            $(this).closest(".swiper")[0].swiper;
            swiperHorizontal.slideNext();
        });
    }

    swiperHorizontal.on("slidesUpdated", videoVolumeSettings);

    let SwiperOptionName = {
        slidesPerView: 1,
        spaceBetween: 10,
        direction: "vertical",
        mousewheel: false,
        allowTouchMove: false,
        autoHeight: false,
        speed: 1000,
        virtual: {
            cache: false,
            renderSlide: function (slide, index) {
                return `
                    <div class="swiper-slide">
                        <div class="swiper-short-video-detail-name-item">
                            <p class="mb-0">Client: <b>${slide.title}</b></p>
                            <p class="mb-0">Category: <b>${slide.label}</b></p>
                        </div>
                    </div>
                `;
            },
            slides: (function () {
                let slides = [];

                $.ajax({
                    url: "/assets/web/default/json/short-video.json",
                    async: false,
                    success: function (data) {
                        // get link parameter of type
                        let type = new URLSearchParams(
                            window.location.search
                        ).get("type");

                        $.each(data, function (key, value) {
                            if (type !== null) {
                                if (value.type.map(lowerCase).includes(type)) {
                                    slides.push(value);
                                }
                            } else {
                                slides.push(value);
                            }
                        });
                    },
                });

                return slides;
            })(),
        },
        on: {
            init: function () {
                // hash
                let hash = window.location.hash;
                if (hash) {
                    let slide = hash.replace("#slide-", "");
                    this.slideTo(
                        this.virtual.slides.findIndex((s) => s.id == slide)
                    );
                }
            },
        },
    };

    $(".swiper-short-video-detail").on(
        "click",
        ".swiper-short-video-item",
        function () {
            // start to play video when swiper-slide-active
            if ($(this).parent().hasClass("swiper-slide-active")) {
                // toggle play/pause video
                let video = $(this).find("video")[0];
                if (video.paused) {
                    // video.play();
                } else {
                    video.pause();
                }
            }
        }
    );

    virtualUpdate();

    swiperHorizontal.on("virtualUpdate", function () {
        virtualUpdate();
    });

    function virtualUpdate() {
        $(".swiper-short-video-detail").each(function () {
            // animation .short-video-actions-overlay
            // off play and pause event
            $(this).find("video").off("play");
            $(this).find("video").off("pause");
            swiperHorizontal.off("slideNextTransitionEnd");
            swiperHorizontal.off("slidePrevTransitionEnd");

            $(this)
                .find("video")
                .on("play", function () {
                    $(this)
                        .parent()
                        .find(".short-video-actions-overlay")
                        .animate(
                            {
                                opacity: 0,
                            },
                            500
                        );
                })
                .on("pause", function () {
                    $(this)
                        .parent()
                        .find(".short-video-actions-overlay")
                        .animate(
                            {
                                opacity: 1,
                            },
                            500
                        );
                });
        });

        // slide change end will play video
        swiperHorizontal.on("slideNextTransitionEnd", function () {
            handleVideoPlay();
        });

        swiperHorizontal.on("slidePrevTransitionEnd", function () {
            handleVideoPlay();
        });

        function handleVideoPlay() {
            $(".swiper-short-video-detail video").each(function () {
                this.pause();
            });
            const video = $(".swiper-slide-active video");

            videoPlayPromise(video[0]);
        }
    }

    $(".swiper-short-video-detail").on("click", ".btn-play", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let video = $(this)
            .closest(".swiper-short-video-item")
            .find("video")[0];

        video.play();
    });

    const swiperVertical = new Swiper(
        ".swiper-short-video-name",
        SwiperOptionName
    );

    swiperHorizontal.on("slideChange", function (swiper) {
        // swiperVertical is array
        swiperVertical.forEach((swiper) => {
            swiper.slideTo(swiperHorizontal.activeIndex);
        });
    });
}
